import Logo from '../images/logo.svg';
import { useState } from "react";
import Burger from '../images/mi_menu.svg'
import CustomDrawer from "./CustomDrawer";
import Home from "../images/home-baner.png";
// import Language from "./DropDown";
import { Link as ScrollLink } from 'react-scroll'; // Import as ScrollLink

const menu = [
  {title: 'Home', href: 'blockOne'},
  {title: 'About', href: 'blockTwo'},
  {title: '', href: 'blockOne', icon: true},
  {title: 'Destinations', href: 'BlockThree'},
  {title: 'Contact', href: 'ContactUsBlock'}
]

const gridItemStyle = {
  backgroundImage: `url(${Home})`,
  backgroundRepeat: 'no-repeat',
  position: 'relative'
}

const Header = () => {
  const [showBurger, setShowBurger] = useState(false);

  const toggleMobileNav = () => {
    setShowBurger(!showBurger);
  };

  return (
    <div className="px-0 pb-0 h-[83vh]">
      <div className="w-full h-full max-h-[780px] flex justify-center bg-cover md:bg-cover" style={gridItemStyle}>
        <div className='flex justify-center items-start gap-x-4 md:gap-x-2 lg:gap-x-8 py-7 w-full px-4'>
          <div className='hidden md:flex gap-x-10 lg:gap-x-20 items-center bg-white opacity-75 rounded-full px-20'>
            {menu.map((item, index) => {
              return (
                <ScrollLink
                  smooth={true}
                  offset={-70}
                  duration={500}
                  to={item.href} key={index} className="text-black text-lg cursor-pointer">{item.icon ? <img alt='svg' src={Logo} /> : item.title}
                </ScrollLink>
              );
            })}
          </div>
          <div className="flex md:hidden gap-x-10 lg:gap-x-20 items-center bg-white opacity-75 rounded-full px-10 md:px-16 w-full justify-between">
            <img alt='svg' src={Logo} />
            {showBurger ?
              <div onClick={toggleMobileNav} className="close-icon open">
                <img className="h-full w-full rotate-90" src={Burger} alt="svg" />
              </div>
              :
              <div onClick={toggleMobileNav} className="burger-icon open">
                <img className="h-full w-full" src={Burger} alt="svg" />
              </div>
            }
          </div>
          {/*<div className="hidden md:flex items-center gap-x-7">*/}
          {/*  <div>*/}
          {/*    <Language />*/}
          {/*  </div>*/}
          {/*</div>*/}
          <CustomDrawer setShowBurger={setShowBurger} showBurger={showBurger} />
        </div>
      </div>
    </div>
  );
};

export default Header;
